'use strict';

exports.__esModule = true;

var _Avatar = require('./Avatar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});
Object.defineProperty(exports, 'AVATAR_SIZES', {
  enumerable: true,
  get: function get() {
    return _Avatar.AVATAR_SIZES;
  }
});
Object.defineProperty(exports, 'AVATAR_SIZE_PX', {
  enumerable: true,
  get: function get() {
    return _Avatar.AVATAR_SIZE_PX;
  }
});

var _AvatarStyled = require('./AvatarStyled');

Object.defineProperty(exports, 'AvatarBox', {
  enumerable: true,
  get: function get() {
    return _AvatarStyled.AvatarBox;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }